// extracted by mini-css-extract-plugin
export default {"ReposCountText":"ReposList-module__ReposCountText--Gr930","ReposListContainer":"ReposList-module__ReposListContainer--Nr1VN"};